'use client';

import Image from 'next/image';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../styles/tailwind-output.css';

export type CarouselProps = {
  data: string[];
};

export function Carousel(props: CarouselProps) {
  const { data } = props;

  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    arrows: false,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots custom-dots',
  };

  return (
    <div className="h-80.5  overflow-hidden">
      <Slider {...settings}>
        {data?.map((item, index) => (
          <div key={index} className="relative z-10 w-full  h-80.5">
            <Image
              src={item}
              alt="banner"
              fill
              loading="lazy"
              placeholder="blur"
              blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKAQMAAAC3/F3+AAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRF/e3kVtF2mQAAAA1JREFUeJxjZGBgxI0AAMMAC8ggFq0AAAAASUVORK5CYII="
              sizes="(max-width: 480px) 100vw"
              className="object-cover z-0"
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}
